import getters from "./getters"
import actions from "./actions"
import mutations from "./mutations"
import cacheLs from "../cacheLs"

const state = {
  selectedUniversity: cacheLs.get_university()
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
